import { render } from "./TicketAccessGate.vue?vue&type=template&id=dfa13d60&scoped=true"
import script from "./TicketAccessGate.vue?vue&type=script&lang=js"
export * from "./TicketAccessGate.vue?vue&type=script&lang=js"

import "./TicketAccessGate.vue?vue&type=style&index=0&id=dfa13d60&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa13d60"]])

export default __exports__